import React from "react";
import {
  Control,
  Controller,
  FieldErrors,
  UseFormSetValue,
} from "react-hook-form";
import { useTranslation } from "react-i18next";
import { NotificationPrefEnum } from "../../../../types/user.definition";
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type StaffFormData = any;

interface NotificationPreferencesProps {
  control: Control<StaffFormData>;
  setValue: UseFormSetValue<StaffFormData>;
  errors?: FieldErrors<StaffFormData>;
}

export const NotificationPreferences: React.FC<
  NotificationPreferencesProps
> = ({ control, setValue }) => {
  const { t } = useTranslation();

  return (
    <div className="col-span-2">
      <Controller
        name="preferredNotificationMethods"
        control={control}
        render={({ field, fieldState }) => {
          const currentMethods = (field.value as string[]) || [];

          const toggleNotificationMethod = (method: string) => {
            const newMethods = currentMethods.includes(method)
              ? currentMethods.filter((m) => m !== method)
              : [...currentMethods, method];
            field.onChange(newMethods);
            setValue(
              "preferredNotificationMethods" as never,
              newMethods as never,
              {
                shouldValidate: true,
                shouldDirty: true,
              }
            );
          };

          return (
            <>
              <label className="block mb-2 text-sm font-medium text-neutral-700">
                {t("staff.manage.form.preferredNotifications")}
              </label>
              <div className="flex gap-4">
                <label className="flex gap-2 items-center cursor-pointer">
                  <input
                    type="checkbox"
                    checked={currentMethods.includes(
                      NotificationPrefEnum.EMAIL
                    )}
                    onChange={() =>
                      toggleNotificationMethod(NotificationPrefEnum.EMAIL)
                    }
                    className="w-4 h-4 rounded border-neutral-300 text-primary-600 focus:ring-primary-500"
                  />
                  <span className="text-sm text-neutral-700">
                    {t("staff.manage.form.notificationEmail")}
                  </span>
                </label>
                <label className="flex gap-2 items-center cursor-pointer">
                  <input
                    type="checkbox"
                    checked={currentMethods.includes(NotificationPrefEnum.SMS)}
                    onChange={() =>
                      toggleNotificationMethod(NotificationPrefEnum.SMS)
                    }
                    className="w-4 h-4 rounded border-neutral-300 text-primary-600 focus:ring-primary-500"
                  />
                  <span className="text-sm text-neutral-700">
                    {t("staff.manage.form.notificationSMS")}
                  </span>
                </label>
              </div>
              {fieldState.error && (
                <p className="mt-1 text-sm text-red-600">
                  {fieldState.error.message}
                </p>
              )}
              <p className="mt-1 text-xs text-neutral-500">
                {t("staff.manage.form.preferredNotificationsHelp")}
              </p>
            </>
          );
        }}
      />
    </div>
  );
};
